import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    availableLayersContainer: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),
      flex: 1,
      display: 'flex',
      flexDirection: 'column',

      '& > header': {
        marginBottom: theme.spacing(1),
        '& > h3': {
          fontSize: '1.6rem',
        },
      },

      '& .MuiFormControlLabel-root': {
        '& .MuiFormControlLabel-label': {
          display: 'inline-flex',
          flex: 1,

          fontWeight: 600,
          fontSize: '1.2rem',

          '& span:first-child': {
            flex: 1,
          },
          '& span:last-child': {
            fontWeight: 400,
          },
        },

        '& .MuiCheckbox-root': {
          padding: '0.4rem',
          marginLeft: '0.4rem',

          '&:not(.Mui-disabled)': {
            color: '#646464',
            '&.Mui-checked, &.MuiCheckbox-indeterminate': {
              color: theme.palette.primary.dark,
            },
          },
        },
      },

      '& button': {
        width: 'max-content',
        height: '3.6rem',
        margin: 0,
        padding: '0 2rem',

        marginTop: 'auto',
      },
    },
    selectedLayersContainer: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 0.5, 1, 1.5),
      flex: 1,

      '& > header': {
        marginBottom: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },
      },

      '& .MuiFormControlLabel-root': {
        '& .MuiFormControlLabel-label': {
          display: 'inline-flex',
          flex: 1,

          fontWeight: 600,
          fontSize: '1.2rem',

          '& span:first-child': {
            flex: 1,
          },
          '& span:last-child': {
            fontWeight: 400,
          },
        },

        '& .MuiCheckbox-root': {
          color: '#646464',
          paddingTop: '0.4rem',
          paddingBottom: '0.4rem',

          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: theme.palette.primary.dark,
          },
        },
      },

      '& ul': {
        listStyle: 'none',
        padding: 0,
        margin: 0,

        '& li': {
          display: 'inline-flex',
          width: '100%',
          gap: '0.4rem',
          alignItems: 'center',

          '& + li': {
            marginTop: '1rem',
          },

          '& > span': {
            flex: 1,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'space-between',

            fontSize: '1.2rem',

            padding: '0.8rem',

            background: '#F0F0F0',
            borderRadius: 5,
          },
        },
      },
    },
    buttonContainer: {
      margin: '1rem 0',

      display: 'flex',
      gap: '1.2rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,

        gap: '1rem',
      },
    },
  }),
)
